export const INITIAL_STATE = {
    isModalOpen: false,
    modalType: null,
    type: null,
    modalProps: {},
};